module.exports = __webpack_public_path__ + "images/emoji/aerial_tramway.182c7d6e7de96445e4aa.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/aerial_tramway.png
// module id = m0IY
// module chunks = 13